<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Loyer hors charges</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/achat.png" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <table>
                <tr>
                    <th>Loyer
                        <i *ngIf="favorite.lots.length > 1 && rentDetail == false" (click)="showRentDetail()" class="fa fa-caret-down"></i>
                        <i *ngIf="favorite.lots.length > 1 && rentDetail == true" (click)="hideRentDetail()" class="fa fa-caret-up"></i>
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Loyer</mat-label>
                            <input matInput [(ngModel)]="favorite.amount_rent" (ngModelChange)="edit($event)" [disabled]="favorite.lots.length > 1">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>

                <ng-container *ngIf="favorite.lots.length > 1 && rentDetail == true">
                    <tr *ngFor="let lot of favorite.lots">
                        <th>{{ lot.title }}</th>
                        <td>
                            <mat-form-field appearance="standard">
                                <mat-label>Loyer</mat-label>
                                <input matInput [(ngModel)]="lot.amount_rent" (ngModelChange)="edit($event)">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </td>
                    </tr>
                </ng-container>

                <tr>
                    <th>
                        Charges de copropriété locataire
                        <i *ngIf="favorite.lots.length > 1 && rentDetail == false" (click)="showChargeDetail()" class="fa fa-caret-down"></i>
                        <i *ngIf="favorite.lots.length > 1 && rentDetail == true" (click)="hideChargeDetail()" class="fa fa-caret-up"></i>
                    </th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Charge de copropriété locataire</mat-label>
                            <input matInput [(ngModel)]="favorite.amount_copro_rent" (ngModelChange)="edit($event)" [disabled]="favorite.lots.length > 1">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </td>
                </tr>

                <ng-container *ngIf="favorite.lots.length > 1 && chargeDetail == true">
                    <tr *ngFor="let lot of favorite.lots">
                        <th>{{ lot.title }}</th>
                        <td>
                            <mat-form-field appearance="standard">
                                <mat-label>Charge de copropriété locataire</mat-label>
                                <input matInput [(ngModel)]="lot.amount_copro_rent" (ngModelChange)="edit($event)">
                                <span matSuffix>€</span>
                            </mat-form-field>
                        </td>
                    </tr>
                </ng-container>

            </table>
        </div>
    </div>
</div>
